<template>
  <div class="glide">
    <div class="glide__track" data-glide-el="track">
      <ul class="glide__slides">
        <li class="glide__slide">
          <img class="fit"
              src="img/brand/mockup_1.png"
              height="600" width="450" rel="nofollow">
        </li>
        <li class="glide__slide">
          <img class="fit"
              src="img/brand/mockup_2.png"
              height="600" width="450" rel="nofollow">
        </li>
        <li class="glide__slide">
          <img class="fit"
              src="img/brand/mockup_3.png"
              height="600" width="450" rel="nofollow">
        </li>
        <li class="glide__slide">
          <img class="fit"
              src="img/brand/mockup_4.png"
              height="600" width="450" rel="nofollow">
        </li>
        <li class="glide__slide">
          <img class="fit"
              src="img/brand/mockup_5.png"
              height="600" width="450" rel="nofollow" >
        </li>
        <li class="glide__slide">
          <img class="fit"
               src="img/brand/mockup_6.png"
               height="600" width="450" rel="nofollow" >
        </li>
      </ul>
    </div>
    <div class="glide__arrows" data-glide-el="controls" >

      <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
        <i class="ni ni-bold-left text-default"></i></button>
      <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><i
          class="ni ni-bold-right text-default"></i></button>
    </div>
  </div>
</template>

<script>
import Glide from '@glidejs/glide'

export default {
  name: "Glide",
  mounted() {
    new Glide('.glide', {type: 'carousel', startAt: 0, perView: 5, autoplay: 5000},).mount();
  },
}
</script>

<style lang="scss" scoped>
.fit {
  object-fit: contain;
}
</style>
